import { FirebaseError } from 'firebase/app';
import { ApplicationError } from './ApplicationError';

export const convertToApplicationError = (error: unknown): ApplicationError => {
  if (error instanceof ApplicationError) {
    return error;
  } else {
    const unknownError = new ApplicationError('PHW-X-001');
    unknownError.cause = error;
    return unknownError;
  }
};

export const errorCode = (error: unknown): string | undefined => {
  const { code } = (error ?? {}) as { code?: unknown };
  return typeof code === 'string' ? code : undefined;
};

export const callableErrorDetails = (
  error: unknown
): { code: string | undefined; httpStatus?: number } => {
  const code = errorCode(error);
  const { message } = (error ?? {}) as { message?: unknown };
  const match =
    code?.startsWith('functions/') && typeof message === 'string'
      ? /\[(\d+)\]$/.exec(message)
      : null;
  return match ? { code, httpStatus: Number(match[1]) } : { code };
};

export const isFirebasePermissionDeniedError = (
  error: unknown
): error is FirebaseError =>
  error instanceof FirebaseError && error.code === 'permission-denied';
